<template>
  <div class="p-2 border-gray-300 rounded-md cursor-pointer border fill-primary hover:fill-white hover:bg-primary group transition-all duration-300">
<svg
     class="w-4 h-4 transition-all duration-300"
     width="" height="" viewBox="0 0 9 5" fill="" xmlns="http://www.w3.org/2000/svg">
<path
    d="M0.00039959 0.588284C-0.00560093 0.35313 0.162021 0.140733 0.417253 0.0590159C0.672885 -0.0227017 0.960921 0.0438447 1.13414 0.22521L4.48977 3.6008L7.84419 0.22521C7.9494 0.101426 8.10982 0.0210879 8.28704 0.00350307C8.46426 -0.0137369 8.64149 0.0331559 8.7767 0.133148C8.91192 0.23314 8.99273 0.376922 8.99953 0.530702C9.00633 0.684138 8.93872 0.833092 8.81311 0.941704L4.97623 4.80657C4.85461 4.92932 4.67659 5 4.48937 5C4.30214 5 4.12412 4.92932 4.0025 4.80657L0.161621 0.941704C0.0608082 0.844125 0.00360107 0.718963 0 0.588284H0.00039959Z"
    fill=""/>
</svg>
  </div>
</template>
